<div class="containerWrapper">
  <div class="accountDetail">
    <!-- First Panel -->
    <mat-accordion>
      <mat-expansion-panel hideToggle opened (closed)="listOpen = false" [expanded]="true" [disabled]="true" #mep1="matExpansionPanel">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div (click)="mep1.expanded = !mep1.expanded; listOpen = !listOpen" [class.openPanel]="listOpen" class="material-icons material-icons-outlined">expand_more</div>
            <h2>{{ 'Account Info' | translate }}</h2>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form [formGroup]="subscriberForm">
          <div class="subscriberForm">
            <div class="left">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'First Name' | translate }}</mat-label>
                <input matInput formControlName="subscriberFN" readonly />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>{{ 'Phone' | translate }}</mat-label>
                <input matInput formControlName="subscriberPhone" readonly />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>{{ 'Status' | translate }}</mat-label>
                <input matInput formControlName="subscriberStatus" readonly />
              </mat-form-field>
            </div>
            <div class="right">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'Last Name' | translate }}</mat-label>
                <input matInput formControlName="subscriberLN" readonly />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>{{ 'Email' | translate }}</mat-label>
                <input matInput formControlName="subscriberEmail" readonly />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>{{ 'Currency' | translate }}</mat-label>
                <input matInput formControlName="currency" readonly />
              </mat-form-field>
            </div>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>

    <!-- Second Panel -->
    <mat-accordion>
      <mat-expansion-panel hideToggle opened (closed)="listInvoiceOpen = false" [expanded]="true" [disabled]="true" #mep2="matExpansionPanel">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div (click)="mep2.expanded = !mep2.expanded; listInvoiceOpen = !listInvoiceOpen" [class.openPanel]="listInvoiceOpen" class="material-icons material-icons-outlined">expand_more</div>
            <h2>{{ 'Subscription' | translate }}</h2>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form [formGroup]="subscriberForm">
          <div class="subscriberForm">
            <div class="left">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'Start Day' | translate }}</mat-label>
                <input matInput type="date" formControlName="startPaymentDate" />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>{{ 'Payment Every' | translate }}</mat-label>
                <input matInput formControlName="paymentDuration" readonly />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'Payment Type' | translate }}</mat-label>
                <input matInput formControlName="paymentType" readonly />
              </mat-form-field>
            </div>
            <div class="right">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'End Day' | translate }}</mat-label>
                <input matInput formControlName="endPaymentDate" type="date" />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>{{ 'Next Payment' | translate }}</mat-label>
                <input matInput formControlName="nextPayent" type="date" />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>{{ 'Number Of Retrials' | translate }}</mat-label>
                <input matInput formControlName="num_retries" readonly />
              </mat-form-field>
            </div>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
